import { create } from "zustand"
import axiosInstance from "@/lib/axiosInstance"

interface CalUser {
    email: string
    fullName: string
    calComUsername: string
}

interface CalResponse {
    success: boolean
    data: CalUser
}

interface CalType {
    calUser: string | null
    isPopupOpen: boolean
    adminCalUser: CalUser | null
    isLoading: boolean
    error: string | null
    setCalUser: (userCalId: string) => void
    openPopup: () => void
    closePopup: () => void
    handleScheduleClick: (callUser?: string) => void
    getAdminCalUser: () => Promise<void>
}

const useCalStore = create<CalType>((set, get) => ({
    calUser: null, // default value
    isPopupOpen: false,
    adminCalUser: null,
    isLoading: false,
    error: null,

    setCalUser: (userCalId: string) => set({ calUser: userCalId }),
    openPopup: () => set({ isPopupOpen: true }),
    closePopup: () => set({ isPopupOpen: false }),
    
    handleScheduleClick: (callUser?: string) => {
        if (callUser) {
            get().setCalUser(callUser) // Set the Cal user
        }
        get().openPopup() // Open the popup
    },

    getAdminCalUser: async () => {
        try {
            set({ isLoading: true, error: null });
            const response = await axiosInstance.get<CalResponse>('/users/admin');
            
            if (response.data.success) {
                set({ 
                    adminCalUser: response.data.data,
                    calUser: response.data.data.calComUsername, // Update the calUser with the fetched username
                    isLoading: false 
                });
            }
        } catch (error) {
            set({ 
                error: error instanceof Error ? error.message : 'Failed to fetch calendar user',
                isLoading: false 
            });
        }
    }
}))

export default useCalStore